<template>
  <el-dialog title="审批" class="global-dialog" :visible.sync="visible" width="600px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form" v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        :rules="rules" ref="form2" label-width="130px">
        <!-- 充值审批 -->
        <template v-if="depositType === '1'">
          <!-- 业务员审批表单 -->
          <template v-if="approvalStatus === '1'">
            <el-form-item prop="depositNumber" label="付款凭证单号">
              <el-input v-model="formData.depositNumber" placeholder="请输入付款凭证单号"></el-input>
            </el-form-item>
            <el-form-item prop="fkBank" label="付款银行">
              <el-input v-model="formData.fkBank" placeholder="请输入付款银行"></el-input>
            </el-form-item>
            <el-form-item prop="receivingBank" label="收款银行">
              <el-select :filterable="true" v-model="formData.receivingBank" placeholder="请选择收款银行">
                <el-option v-for="item of skyhList" :key="item.value" :label="item.dicCode"
                  :value="item.dicCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="depositChange" label="金额">
              <el-input v-model="formData.depositChange" placeholder="请输入金额"></el-input>
            </el-form-item>
            <el-form-item prop="transferDate" label="汇款日期">
              <el-date-picker v-model="formData.transferDate" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择汇款日期"></el-date-picker>
            </el-form-item>
          </template>
          <!-- 财务审批表单 -->
          <template v-if="approvalStatus === '2'">
            <el-form-item prop="skNumber" label="收款凭证单号">
              <el-input v-model="formData.skNumber" placeholder="请输入收款凭证单号"></el-input>
            </el-form-item>
            <el-form-item prop="transferDate" label="收款日期">
              <el-date-picker v-model="formData.transferDate" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择收款日期"></el-date-picker>
            </el-form-item>
            <el-form-item prop="depositChange" label="收款金额">
              <el-input v-model="formData.depositChange" placeholder="请输入收款金额"></el-input>
            </el-form-item>
          </template>
        </template>
        <!-- 退还审批 -->
        <!-- 退还审批无其他表单填写 -->

        <!-- 转换审批 -->
        <!-- 转换审批无其他表单填写 -->
        <el-form-item prop="approvalStatus" label="审批状态">
          <el-radio-group v-model="formData.approvalStatus">
            <el-radio label="2">审核通过</el-radio>
            <el-radio label="3">审核驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="approvalComments" label="审批意见">
          <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入审批意见"
            v-model="formData.approvalComments">
          </el-input>
        </el-form-item>
        <el-form-item label="附件">
          <file-upload v-model="formData.fileList"></file-upload>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>
    <!-- <image-viewer :visible.sync="dialogVisible" :initial-index="currentImageIndex" :url-list="imageList"></image-viewer> -->

  </el-dialog>
</template>
<script>
export default {
  name: 'FundApprovalDialog',
  props: {
    relatedId: {
      type: String,
      default: ''
    },
    depositType: {
      type: String, // 1：充值 2：退还 3：转换
      default: ''
    },
    approvalStatus: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  data() {
    return {
      skyhList: [],
      statusList2: [
        {
          label: '审批通过',
          value: '2'
        },
        {
          label: '审批驳回',
          value: '3'
        }
      ],
      formData: {
        relatedId: '',
        fkBank: '',
        depositNumber: '',
        skNumber: '',
        approvalStatus: '',
        depositChange: '', // 充值/退还/转换金额
        approvalComments: '', // 审批意见
        transferDate: '', // 收款日期
        receivingBank: '', // 收款银行
        fileList: []
      },
      rules: {
        approvalStatus: [
          {
            required: true,
            message: '请选择审批状态',
            trigger: ['blur', 'change']
          }
        ],
        isVehicle: [
          {
            required: true,
            message: '请选择车辆预约',
            trigger: ['blur', 'change']
          }
        ],
        vehicleDateStart: [
          {
            required: true,
            message: '请选择开始时间',
            trigger: ['blur', 'change']
          }
        ],
        approvalComments: [
          {
            required: true,
            message: '请输入审批意见',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false
    }
  },
  computed: {
  },
  created() {
    this.loadDict()
  },
  methods: {
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'skyh' }
      }).then(res => {
        this.skyhList = res.skyh || []
      })
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    submitDlg() {
      this.$refs.form2.validate().then(() => {
        this.formData.relatedId = this.relatedId
        this.$axios.post(this.$apis.bondRecord.approvaYxUserDepositNew, this.formData).then(() => {
          this.$emit('success')
          this.handleClose()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
